module.exports = __webpack_public_path__ + "img/OperationsHistory.018e71ad.svg";